import { isNull, get } from "lodash"
import locales from "./../../../content.json"

const BOTTOM_LINE_FT = 3
const TOP_LINE_FT = 8
const BELOW_BOTTOM_LINE_FT_MESSAGE = locales[window.userLang].height_warning
const ABOVE_TOP_LINE_FT_MESSAGE = locales[window.userLang].height_warning

const BOTTOM_LINE_CM = 100
const TOP_LINE_CM = 220
const BELOW_BOTTOM_LINE_CM_MESSAGE = locales[window.userLang].height_warning
const ABOVE_TOP_LINE_CM_MESSAGE = locales[window.userLang].height_warning

export const checkIsValidFtHeight = data => {
    return validateHeightFtStep(get(data, ["height", "value"], "")) && !data.height.isValid
}

export const checkIsValidCmHeight = data => {
    return validateHeightCmStep(get(data, ["height", "value"], "")) && !data.height.isValid
}

export const checkIsChoosedHeightType = (data, type) => {
    return get(data, ["height", "type"], null) === type
}

export const isFailureFtValidation = data => {
    return !validateHeightFtStep(get(data, ["height", "value"], ""))
        && get(data, ["height", "validString"], "") !== getValidateFtMessage(get(data, ["height", "value"], ""))
}

export const isFailureCmValidation = data => {
    return !validateHeightCmStep(get(data, ["height", "value"], ""))
    && get(data, ["height", "validString"], "") !== getValidateCmMessage(get(data, ["height", "value"], ""))
}

export const validateHeightCmStep = value => {
    return !isNull(value)
        ? value >= BOTTOM_LINE_CM && value <= TOP_LINE_CM
        : false
}

export const getValidateCmMessage = value => {
    let message = ""

    if (!isNull(value))
        if (value <= BOTTOM_LINE_CM)
            message = BELOW_BOTTOM_LINE_CM_MESSAGE
        else if (value >= TOP_LINE_CM)
            message = ABOVE_TOP_LINE_CM_MESSAGE

    return message
}

export const validateHeightFtStep = value => {
    return !isNull(value)
        ? value >= BOTTOM_LINE_FT && value <= TOP_LINE_FT
        : false
}

export const getValidateFtMessage = value => {
    let message = ""

    if (!isNull(value))
        if (value <= BOTTOM_LINE_FT)
            message = BELOW_BOTTOM_LINE_FT_MESSAGE
        else if (value >= TOP_LINE_FT)
            message = ABOVE_TOP_LINE_FT_MESSAGE

    return message
}

export const heightTypeData = {
    ft: {
        value: "ft",
        title: locales[window.userLang].height_ft,
    },
    cm: {
        value: "cm",
        title: locales[window.userLang].height_cm,
    },
}